export type StoredTokens = {
  accessToken: string | null;
  refreshToken: string | null;
};

const ACCESS_KEY = "auth.access_token";
const REFRESH_KEY = "auth.refresh_token";

export function setTokens(
  accessToken: string | null,
  refreshToken?: string | null
) {
  if (accessToken) {
    localStorage.setItem(ACCESS_KEY, accessToken);
  }
  if (typeof refreshToken !== "undefined") {
    if (refreshToken) {
      localStorage.setItem(REFRESH_KEY, refreshToken);
    } else {
      localStorage.removeItem(REFRESH_KEY);
    }
  }
}

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_KEY);
}

export function clearTokens() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}

export function updateTokensFromHeaders(
  headers: Headers | Record<string, string | undefined>
) {
  const get = (name: string) => {
    if (headers instanceof Headers) return headers.get(name) || undefined;
    const key = Object.keys(headers).find(
      (k) => k.toLowerCase() === name.toLowerCase()
    );
    return key ? headers[key] : undefined;
  };

  const newAccess =
    get("x-access-token") ||
    get("x-new-access-token") ||
    get("authorization-bearer");
  const newRefresh = get("x-refresh-token") || get("x-new-refresh-token");

  if (newAccess || newRefresh) {
    setTokens(newAccess || null, newRefresh || null);
  }
}
